import { Stack } from 'expo-router';

export default function RachaLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
